export default "__VITE_ASSET__96b353d3__"